import { InputSkeleton } from '@/_components';
import { CardContainer, FormLayout, SectionHeadingSkeleton } from '@/_containers';
import { RichTextLoader } from '@/_containers/inputs/rich-text';
const richTexts = new Array(5).fill(0);

export default function Loading() {
  return (
    <>
      <CardContainer>
        <SectionHeadingSkeleton />
        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
        </FormLayout>
      </CardContainer>

      {richTexts.map((_, index) => (
        <CardContainer key={`rich-text-loader-${index}`}>
          <SectionHeadingSkeleton />
          <FormLayout>
            <RichTextLoader inline className="col-span-12" />
          </FormLayout>
        </CardContainer>
      ))}
    </>
  );
}
